import type { ReadonlyDeep } from 'type-fest';

import { MaterialInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';
import { costUsageForm2ApiMapper } from '../../CostUsage/mappers/cost-usage.form2api.mapper';

import type { MaterialForm_Material } from '../fragments/material.fragment';
import type { MaterialInput as IMaterialInput } from '../hooks/useCreateMaterialMutation.hook';

export function materialForm2ApiMapper(
  material: ReadonlyDeep<MaterialForm_Material>,
): ReadonlyDeep<IMaterialInput> {
  const materialInput = pruneInput(material, MaterialInput);

  return {
    ...materialInput,
    costUsages: material.costUsages.map(costUsageForm2ApiMapper),
    codingConfig: codingConfigForm2ApiMapper(material.codingConfig),
  };
}
